import React from 'react';
import { Link } from 'react-router-dom';
import CommunityHub from './CommunityHub';

const PLATFORM_TOOLS = [
  { to: '/assessments', label: 'Assessments' },
  { to: '/reports', label: 'Reports' },
  { to: '/pipeline', label: 'Pipeline' },
  { to: '/lenses', label: 'Lenses' },
  { to: '/seven-gen', label: '7 Generation Plan' },
  { to: '/land-intelligence', label: 'Land Intelligence' },
];

export default function StaffDashboard() {
  return <>
    <CommunityHub />
    <details className="page">
      <summary>Platform staff tools</summary>
      <p>Community collection and planning tools are inside each community above.</p>
      <nav className="community-tool-links" aria-label="Platform staff tools">
        {PLATFORM_TOOLS.map(({ to, label }) => <Link key={to} to={to}>{label}</Link>)}
      </nav>
    </details>
  </>;
}
